<template>
  <section>
    <div
      :id="questionId"
      :name="name"
      :type="attributeType"
      class="questionModel"
      @clearValue="clearValue()"
      @disableInput="disableInput()"
      @enableInput="enableInput()"
      @enableRequired="enableRequired()"
      @removeRequired="removeRequired()"
    >
      <b-row class="mx-0">
        <b-col cols="10">
          <label class="questionLabelStyle"
            ><span v-if="isRequired" class="requiredStar">* </span>{{ label }}</label
          >
          <div v-if="helpText">
            <p class="helpTextStyle"><span v-html="helpText"></span></p>
          </div>
        </b-col>
        <b-col>
          <response-history
            v-show="selectedAnswerId"
            :options="options"
            :questionId="questionId"
            :surveyType="validationsType"
            :type="'multiPicklist'"
          />
        </b-col>
      </b-row>
      <b-col>
        <validation-observer ref="observer">
          <validation-provider
            ref="provider"
            v-slot="validationContext"
            :rules="`${isRequired ? 'required' : ''}`"
          >
            <div :class="inputBoxStyle">
              <multiselect
                :id="questionId + '_value'"
                v-model="selected"
                :clear-on-select="false"
                :close-on-select="false"
                :multiple="true"
                :options="options"
                :preserve-search="true"
                :state="getValidationState(validationContext)"
                aria-describedby="validationFeedback"
                label="Label__c"
                placeholder="Please select your answers"
                track-by="Label__c"
                @input="changeItem($event)"
              >
              </multiselect>
            </div>

            <b-form id="validationFeedback" class="validationFeedbackStyle"
              >{{ validationContext.errors[0] }}
            </b-form>
          </validation-provider>
        </validation-observer>
      </b-col>
    </div>
  </section>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import ResponseHistory from './ResponseHistory.vue';

  export default {
    name: 'MultiDropdown',
    components: {
      ResponseHistory,
      Multiselect,
    },
    props: [
      'label',
      'options',
      'dependencyMap',
      'questionId',
      'answer',
      'dependentQuestion',
      'requiredQuestions',
      'attributeType',
      'validationsType',
      'helpText',
      'name',
      'selectedLimit',
    ],
    data() {
      return {
        disabled: false,
        inputBoxStyle: { invalid: false, valid: false },
        myDirty: false,
        selected: [],
        selectedAnswerAndId: {},
        selectedAnswer: '',
        selectedAnswerId: '',
        count: 0,
        isRequired: false,
      };
    },
    watch: {
      async validationTrigger(newVal, oldVal) {
        if (
          this.requiredQuestions.includes(this.questionId) &&
          newVal.includes(this.validationsType)
        ) {
          let data = [];
          data[0] = this.questionId;
          data[1] = await this.$refs.observer.validate();
          this.$store.commit(this.validationsType, data);
          this.myDirty = true;
        }
      },
    },
    created() {
      for (let i = 0; i < Object.keys(this.options).length; i++) {
        this.selectedAnswerAndId[this.options[i]['Value__c']] = this.options[i]['Id'];
        this.options[i]['label'] = this.options[i]['Label__c'];
      }
      if (this.answer === undefined || this.answer[0]['Saved_Value_Long__c'] === undefined) {
        this.selectedAnswer = undefined;
      } else {
        this.selectedAnswer = this.answer[0]['Saved_Value_Long__c'];
        for (const index of this.options.keys()) {
          if (this.selectedAnswer.includes(this.options[index]['Value__c'])) {
            this.selected.push(this.options[index]);
          }
        }
      }
      if (this.answer === undefined) {
        this.selectedAnswerId = undefined;
      } else {
        this.selectedAnswerId = this.answer[0]['Id'];
      }

      if (this.answer !== undefined) {
        this.emitValue(this.answer[0]['Saved_Value_Long__c']);
      }
      if (this.requiredQuestions.includes(this.questionId)) {
        this.isRequired = true;
      } else {
        this.isRequired = false;
        this.$nextTick(() => {
          this.$refs.observer.reset();
        });
      }
    },
    computed: {
      ...mapGetters(['validationTrigger']),
    },
    mounted() {
      if (document.getElementById(this.questionId).classList.contains('hideElement')) {
        this.isRequired = false;
        this.$nextTick(() => {
          this.$refs.observer.reset();
        });
      }
      let answersWithDependency = [];
      this.selected.forEach(x => {
        if (Object.keys(this.dependencyMap).includes(this.selectedAnswerAndId[x.Label__c])) {
          answersWithDependency.push(x.Label__c);
        }
      });
      let i = 0;
      do {
        this.checkDependentQuestion(
          answersWithDependency[i],
          this.selectedAnswerAndId[answersWithDependency[i]],
        );
        i++;
      } while (i < answersWithDependency.length);
      this.count = 1;
    },
    methods: {
      ...mapActions(['dirtySurvey']),
      getValidationState({ dirty, validated, valid = null, required }) {
        if (dirty) {
          this.myDirty = true;
        }
        if (required) {
          this.setValidationStyle(dirty, validated, valid);
        }
      },
      setValidationStyle(dirty, validated, valid) {
        if (!this.disabled && !valid && this.myDirty) {
          this.inputBoxStyle.invalid = true;
          this.inputBoxStyle.valid = false;
        } else if (!this.disabled && valid && this.myDirty) {
          this.inputBoxStyle.invalid = false;
          this.inputBoxStyle.valid = true;
        } else if (this.disabled) {
          this.inputBoxStyle.invalid = false;
          this.inputBoxStyle.valid = false;
        }
        return dirty || validated ? valid : null;
      },
      changeItem() {
        this.inputBoxStyle.invalid = false;
        let event = [];
        this.selected.forEach(element => {
          event.push(element.Value__c);
        });
        if (this.limitCheck(event)) {
          this.dirtySurvey(this.validationsType);
          let lovId;
          for (let ev in event) {
            if (this.dependencyMap[this.selectedAnswerAndId[event[ev]]] !== undefined) {
              lovId = this.selectedAnswerAndId[event[ev]];
              break;
            } else {
              lovId = this.selectedAnswerAndId[event[event.length - 1]];
            }
          }
          this.$emit('input', { value: event.toString(), id: this.selectedAnswerId });
          this.disableDependentQuestion(lovId);
        }
      },
      limitCheck(event) {
        if (Object.keys(event).length > this.selectedLimit) {
          alert(
            `You have reached the limit of ${this.selectedLimit} selected answers for this question.`,
          );
          this.selected = this.selected.slice(0, this.selectedLimit);
          return false;
        }
        return true;
      },
      clearValue() {
        this.selected = [];
        this.$emit('input', { value: '', id: this.selectedAnswerId });
      },
      removeRequired() {
        this.isRequired = false;
      },
      enableRequired() {
        if (this.requiredQuestions.includes(this.questionId)) {
          this.isRequired = true;
        }
      },
      emitValue(savedValue) {
        this.$emit('input', { value: savedValue.toString(), id: this.selectedAnswerId });
      },
      disableDependentQuestion(lovId) {
        if (this.dependentQuestion != null) {
          this.dependentQuestion.forEach(element => {
            document.getElementById(element).dispatchEvent(new Event('disableInput'));
            document.getElementById(element).dispatchEvent(new Event('removeRequired'));
          });

          this.dependentQuestion.forEach(element => {
            if (typeof this.dependencyMap[lovId] !== 'undefined') {
              if (this.dependencyMap[lovId].includes(element)) {
                document.getElementById(element).dispatchEvent(new Event('enableInput'));
                document.getElementById(element).dispatchEvent(new Event('enableRequired'));
              } else {
                document.getElementById(element).dispatchEvent(new Event('disableInput'));
                document.getElementById(element).dispatchEvent(new Event('removeRequired'));
              }
            } else {
              if (this.count == 1) {
                let parentElement = document.getElementById(element);
                parentElement.dispatchEvent(new Event('clearValue'));
              }
            }
          });
        }
      },
      checkDependentQuestion(selectedAnswer, selectedAnswerId) {
        if (selectedAnswer) {
          let lovId = selectedAnswerId;
          this.disableDependentQuestion(lovId);
        } else if (this.dependentQuestion) {
          this.dependentQuestion.forEach(element => {
            document.getElementById(element).dispatchEvent(new Event('disableInput'));
          });
        }
      },
      disableInput() {
        document.getElementById(this.questionId).classList.add('hideElement', 'pl-5');
        document.getElementById(this.questionId + '_value').setAttribute('hideElement', 'true');
        this.disabled = true;
      },
      enableInput() {
        document.getElementById(this.questionId).classList.remove('hideElement');
        document.getElementById(this.questionId + '_value').removeAttribute('hideElement');
        this.disabled = false;
      },
    },
  };
</script>
<style src="../../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .validationFeedbackStyle {
    width: 100%;
    font-size: 80%;
    color: #dc3545;
  }

  .invalid .multiselect__tags {
    border-color: #dc3545;
  }

  .valid .multiselect__tags {
    border-color: #28a745;
  }

  .multiselect__tag {
    background: #007bff;
    color: white;
  }

  .multiselect__tag-icon:after {
    color: white;
    font-size: 20px;
  }

  .multiselect__tag-icon:hover {
    background: #ff5733 !important;
  }

  .multiselect__tag-icon:hover:after {
    color: white;
    font-size: 20px;
  }
</style>
